export function getValidButtonType(type) {
  const validTypes = ['button', 'submit', 'reset'];

  if (validTypes.includes(type)) {
    return type;
  }

  return 'button'; // Default to 'button' if the provided type is not valid
}
